import {createContext} from 'react';

export const LinguagemContext = createContext();
